/**
 * In-app Documentation catalog — sourced from repo docs/*.md
 * (bundled via raw-loader in vue.config.js).
 */
import hosting from '../../docs/HOSTING.md'
import auth from '../../docs/AUTH.md'
import demo from '../../docs/DEMO.md'
import mlsVendor from '../../docs/MLS-VENDOR.md'
import mlsGrid from '../../docs/mls-grid.md'
import handshake from '../../docs/BROKURZ-MLS-HANDSHAKE.md'
import appsAutomation from '../../docs/BROKURZ-APPLICATIONS-AUTOMATION.md'

export const DOCS = [
  {
    slug: 'handshake',
    title: 'Brokurz MLS handshake',
    summary: 'Readiness, feeds ownership, Applications activate loop, current vendor status.',
    file: 'docs/BROKURZ-MLS-HANDSHAKE.md',
    markdown: handshake,
  },
  {
    slug: 'mls-vendor',
    title: 'MLS vendor & feeds',
    summary: 'Vendor model, live Grid/Trestle/Bridge status, fees, licensing.',
    file: 'docs/MLS-VENDOR.md',
    markdown: mlsVendor,
  },
  {
    slug: 'mls-grid',
    title: 'MLS Grid sync notes',
    summary: 'OriginatingSystemName, MlgCanView, lookups, usage limits.',
    file: 'docs/mls-grid.md',
    markdown: mlsGrid,
  },
  {
    slug: 'applications',
    title: 'Applications automation',
    summary: 'Pending Brokurz requests → Grid packet → Activate + notify.',
    file: 'docs/BROKURZ-APPLICATIONS-AUTOMATION.md',
    markdown: appsAutomation,
  },
  {
    slug: 'hosting',
    title: 'Hosting (Render)',
    summary: 'Production host decision, cost, deploy shape, cron vs worker.',
    file: 'docs/HOSTING.md',
    markdown: hosting,
  },
  {
    slug: 'auth',
    title: 'Auth & operators',
    summary: 'Supabase auth, superadmin, invites, GraphQL protection.',
    file: 'docs/AUTH.md',
    markdown: auth,
  },
  {
    slug: 'demo',
    title: 'Demo walkthrough',
    summary: 'How to walk the team through the admin UI.',
    file: 'docs/DEMO.md',
    markdown: demo,
  },
]

/** Map markdown relative links like ./AUTH.md → /docs/auth */
export const MD_FILE_TO_SLUG = {
  'HOSTING.md': 'hosting',
  'AUTH.md': 'auth',
  'DEMO.md': 'demo',
  'MLS-VENDOR.md': 'mls-vendor',
  'mls-grid.md': 'mls-grid',
  'BROKURZ-MLS-HANDSHAKE.md': 'handshake',
  'BROKURZ-APPLICATIONS-AUTOMATION.md': 'applications',
}

export function getDocBySlug(slug) {
  return DOCS.find(d => d.slug === slug) || null
}
